import { ScheduleItem, Tag, onLangChange } from '@hub/shared'
import { useEffect, useMemo, useRef, useState } from 'react'
import { SubscriptionLike } from 'rxjs'
import './campaign-calendar.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaignSchedule: ScheduleItem
  socialNetwork?: string
}

export default ({ className = '', id = '', campaignSchedule, socialNetwork = 'instagram' }: Props) => {
  const onLangChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [dayWeek, setDayWeek] = useState('')
  const [day, setDay] = useState(0)
  const [month, setMonth] = useState('')
  const [lang, setLang] = useState<string>('en')
  const [tagSocial, setTagSocial] = useState({
    value: 'instagram',
    name: 'Instagram',
    icon: 'fa-brands fa-instagram',
  })

  const socialNetworks = useMemo(
    () => [
      {
        value: 'instagram',
        name: 'Instagram',
        icon: 'fa-brands fa-instagram',
      },
      {
        value: 'youtube',
        name: 'Youtube',
        icon: 'fa-brands fa-youtube',
      },
      {
        value: 'tiktok',
        name: 'TikTok',
        icon: 'fa-brands fa-tiktok',
      },
      {
        value: 'twitter',
        name: 'Twitter',
        icon: 'fa-brands fa-x-twitter',
      },
    ],
    []
  )

  useEffect(() => {
    const date = new Date(`${campaignSchedule.date}T00:00:00`)

    onLangChangeSubscription.current = onLangChange.subscribe((lang) => {
      setLang(lang)
      const month = date.toLocaleString(lang, { month: 'short' })
      const weekday = date.toLocaleString(lang, { weekday: 'short' })
      setDay(date.getDate())
      setMonth(month)
      setDayWeek(weekday)
    })

    setTagSocial(socialNetworks.find((item) => item.value === socialNetwork))

    return () => {
      onLangChangeSubscription?.current?.unsubscribe()
    }
  }, [campaignSchedule, socialNetwork, socialNetworks])

  return (
    <div className={`campaign-card ${className} display-flex justify-content-flex-start`} id={id}>
      <div className="card-date-calendar mr-2">
        <span>
          {dayWeek}
          <br />
          <span className="text-big">{day}</span>
          <br />
          {month}
        </span>
      </div>
      <div>
        <div className={'mb-2'}>
          <Tag className="p-2" icon={<i className={`${tagSocial?.icon} ${tagSocial.value} lg`}></i>} labels={[tagSocial?.name]} />
        </div>

        <div className="display-flex justify-content-flex-start`">
          {campaignSchedule?.post ? (
            <Tag
              className="mr-2 p-2"
              icon={<i className="fa-regular fa-camera-retro lg"></i>}
              labels={[<span className="text-bold">{campaignSchedule?.post}</span>, 'posts']}
            />
          ) : null}
          {campaignSchedule?.reel ? (
            <Tag
              className="mr-2 p-2"
              icon={<i className="fa-regular fa-tv-retro lg"></i>}
              labels={[<span className="text-bold">{campaignSchedule?.reel}</span>, 'reels']}
            />
          ) : null}
          {campaignSchedule?.story ? (
            <Tag
              className="p-2"
              icon={<i className="fa-regular fa-film lg"></i>}
              labels={[<span className="text-bold">{campaignSchedule?.story}</span>, 'stories']}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
